import React, { useState, useEffect } from "react";
import {
    Box,
    Grid2,
    Typography,
    Tabs,
    Tab,
    Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { BasicLayout } from '../../layouts/BasicLayout';
import SearchFilter from '../../components/common/SearchFilter';
import { ReactComponent as UnAssigned } from "../../assets/logos/unassigned.svg";
import { ReactComponent as Assigned } from "../../assets/logos/assigned.svg";
import { ReactComponent as Delivered } from "../../assets/logos/delivered.svg";
import { ReactComponent as Intransit } from "../../assets/logos/in-transit.svg";
import { ReactComponent as Expired } from "../../assets/logos/expired.svg";
import { ReactComponent as UnAssignedActive } from "../../assets/logos/unassigned_active.svg";
import { ReactComponent as AssignedActive } from "../../assets/logos/assigned_active.svg";
import { ReactComponent as DeliveredActive } from "../../assets/logos/delivered_active.svg";
import { ReactComponent as IntransitActive } from "../../assets/logos/in-transit_active.svg";
import { ReactComponent as ExpiredActive } from "../../assets/logos/expired_active.svg";
import { requestorTabOptions } from '../../data/UsersPage';
import PackageListingTable from "../../components/PackageListing/PackageListingTable";
import { getStorageValue } from "../../utils/helper";
import { useNavigate, useLocation } from "react-router-dom";
import UserListAPI from '../../utils/services/userList.api';
import NotificationsListAPI from "../../utils/services/notifications.api";

function CustomTabPanel(props) {
    const { children, value, index } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

function MyRequestPage(){
    const location = useLocation();
    const [tabValue, setTabValue] = useState(
        location?.state?.status ? location?.state?.status - 1 : getStorageValue("RequestTabs") ? Number(getStorageValue("RequestTabs")) : 0
    );    
    const [countData, setCountData] = useState({});
    const [isShowNotifications, setShowNotifications] = useState(false);
    const iconList = [<UnAssigned />, <Assigned />, <Intransit />, <Delivered />, <Expired />];
    const activeIconList = [<UnAssignedActive />, <AssignedActive />, <IntransitActive />, <DeliveredActive />, <ExpiredActive />];
    const userId = getStorageValue("userId");
    const navigate = useNavigate();
    const { getUserRequestorListingCount} = UserListAPI;
  const { checkUnreadNotifications } = NotificationsListAPI;

    // API Call to get Table data Count
    const getListingDataCount = async () => {
        const response = await getUserRequestorListingCount(userId);
        if (response.status === "success") {
            setCountData([
                response.data.unassigned,
                response.data.assigned,
                response.data.intransit,
                response.data.delivered,
                response.data.expired,
            ])
        }
    };

    const handleVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
          const checkDate = new Date()?.toISOString();
            const response = await checkUnreadNotifications(userId, checkDate);
            if(response?.data?.message) {
              localStorage.removeItem("isClicked");
              localStorage.setItem("isReload", response?.data?.message);
              localStorage.setItem("notifications", response?.data?.message);
              setShowNotifications(response?.data?.message);
            }
        } 
      };

    useEffect(() => {
        getListingDataCount();
        document.addEventListener('visibilitychange', handleVisibilityChange);
      
        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getListingDataCount();
        // eslint-disable-next-line
    }, [tabValue]);

    useEffect(() => {
        if(location?.state?.status) {
            localStorage.setItem("RequestTabs", location?.state?.status - 1);
        }
    }, [location])

    const handleDeleteSuccess = () => {
        getListingDataCount();
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        localStorage.setItem("RequestTabs", newValue);
    };

    return (
        <BasicLayout isShowNotifications={isShowNotifications}>
            <Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h5" fontWeight={500} fontSize={24}>
                    My Request
                </Typography>
                <Button
                    style={{ textTransform: "none", backgroundColor: "#0C68F4"  }}
                    variant="contained"
                    size="medium"
                    startIcon={<AddIcon />}
                    onClick={() => {
                    navigate("/create-package", {state: {backURL: "/MyRequest", status: tabValue + 1}});
                    }}
                >
                    Create New
                </Button>
                </Box>
            </Box>
            <Grid2>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs value={tabValue} onChange={handleTabChange} className="tab-img">
                            {requestorTabOptions.map((ele, idx) => {
                                return (
                                    <Tab
                                    sx={{ textTransform: "none", fontSize: "13px", paddingBottom: "0px", minHeight: '50px' }}
                                    iconPosition="start"
                                    icon={
                                        idx === tabValue ? activeIconList[idx] : iconList[idx]
                                    }
                                    label={
                                        <p>
                                        <span style={{ color: idx === tabValue ? "black" : '#7C8DB5' }}> {ele} </span> (
                                        <span style={{ fontWeight: "500px" }}>
                                            {countData[idx] !== undefined ? countData[idx] : 0}
                                        </span>
                                        )
                                        </p>
                                    }
                                    />
                                );
                            })}
                        </Tabs>
                    </Box>
                    {requestorTabOptions.map((ele, idx) => {
                    return (
                        <CustomTabPanel key={ele + "Id"} value={tabValue} index={idx}>
                            <SearchFilter
                                childComponent={
                                    <PackageListingTable requestedBy={userId} type={idx+1} 
                                        onDeleteSuccess={handleDeleteSuccess} originPage="MyRequest" />
                                }
                                filterCondition={true}
                                // eslint-disable-next-line
                                typeId={idx == 0 ? idx+2 : idx+1} 
                                searchPage="package"
                                defaultValue="1"
                                defaultFilterValue="All"
                            />
                        </CustomTabPanel>
                    );
                    })}
                </Box>
            </Grid2>
        </BasicLayout>
    )
};

export default MyRequestPage;